define('views/profile/invite',[
    'views/_base/baseview',
    'text!views/profile/invite.html',
    'views/shared/button/button'
], function (BaseView, Template, ButtonComponent){
    'use strict';

    return BaseView.extend({
        id      : 'profile-invite-container',
        tagName : 'div',
        isRender: true,
        template: _.template(Template),
        events  : {
            'submit': 'sendInvite',
            'click .js-profile-invite-save-btn'  : 'sendInvite',
            'click .js-profile-invite-cancel-btn': 'cancelInvite',
            'blur .js-invite-email-input': 'checkEmail',
        },
        initialize: function(options){
            options = options || {};

            this.elementName = options.elementName;

            BaseView.prototype.initialize(this);
        },

        render: function(){
            var that = this;

            this.$el.html(this.template());

            return this;
        },

        loadData: function(){

            this.invite_button = new ButtonComponent({
                // General
                elementName        : '.js-profile-invite-button-container',
                calling_view       : this,
                // Transactional
                is_transaction     : false,
                // Default
                btn_label          : 'Send Invitation',
                btn_callback       : this.sendInvite,
                btn_retry_callback : this.sendInvite,
                // Confirm
                btn_confirm        : false,
                // Cancel
                btn_cancel         : true,
                btn_cancel_label   : 'Cancel',
                btn_cancel_callback: this.cancelInvite,
                // Success
                btn_success        : true,
                btn_success_delay  : 700,
                btn_success_label  : 'OK',
                btn_success_message: 'Invite successfully sent',
                btn_success_callback: this.inviteSaveSuccess,
                // Error
                btn_error          : true,
                btn_error_delay    : 700,
                btn_error_label    : 'Retry',
                btn_error_cancel_label: 'Cancel',
                btn_error_message  : 'Invite could not be sent',
                btn_error_callback : this.canceledOnError
            });

        },

        inviteSaveSuccess: function(resetButton, that){
            var that = (that) ? that : this;
            that.clearForm();
            that.formSubmitted = false;

            if(resetButton.name){
                that.invite_button[resetButton.name]();
            } else {
                resetButton(that.invite_button);
            }
            
        },

        canceledOnError: function(that){
            var that = (that) ? that : this;
            that.formSubmitted = false;
        },

        checkEmail: function(){
            var that = this,
                email = $('.js-invite-email-input'),
                email_feedback = $('.js-invite-email-name-input-feeback');
            // Delay validation check to see if user is trying to submit form to avoid conflict
            setTimeout(function(){
                if(!that.formSubmitted){
                    that.validateEmail(email, email_feedback);
                }
            },300);
        },

        cancelInvite: function(){
            pf.navigate('#profile');
        },

        validateName: function(item, item_feedback){
            var isValid = true;

            // validate first name
            if(item.val() == "" || !item.val() || !(item.val().length >= 2)){
                styleInputError(item);
                isValid = false;
            } else {
                styleInputValid(item);
            }
            // if either first or last are invalid
            if(isValid){
                removeErrorMsg(item_feedback);
                return true;
            } else {
                addErrorMsg(item_feedback, 'Enter at least 2 characters');
                return false;
            }
        },

        validateEmail: function(item, item_feedback){
            if(item.val() == "" || !item.val()){
                feedbackError(item, item_feedback, sysText['FV']['required']['email']);
                return false;
            } else if(!isEmail(item.val())){
                feedbackError(item, item_feedback, sysText['FV']['invalid']['email']);
                return false;
            } else {
                var return_value = false;
                $.ajax({
                    type   : 'POST',
                    async  : false,
                    url    : pf.userURL + '/SignUp',
                    data   : JSON.stringify({ Email:encrypt(item.val()) }),
                    contentType: 'application/json',
                    success: function (response) {
                        var Success = response.Success;
                        var SignUpEmailExists = response.SignUpEmailExists;
                        var userExists = response.userExists;

                        if (userExists == true) {

                            feedbackError(item, item_feedback, sysText['FV']['invalid']['emailExists']);
                            return_value = false;

                        } else if(SignUpEmailExists || Success){
                            
                            feedbackValid(item, item_feedback);
                            return_value = true;

                        }
                    },
                    error: function (response) {
                        return_value = false;
                    }
                });

                return return_value;
            }
        },

        clearForm: function(that){
            var that = (that) ? that : this;
            
            that.$('.js-invite-first-name-input').val('');
            that.$('.js-invite-first-name-input-feeback').removeClass('md-input--filled');
            that.$('.js-invite-last-name-input').val('');
            that.$('.js-invite-last-name-input-feeback').removeClass('md-input--filled');
            that.$('.js-invite-email-input').val('');
            that.$('.js-invite-email-name-input-feeback').removeClass('md-input--filled');
            // that.$('#phone').val('');
            // that.$('#phone').removeClass('md-input--filled');
        },

        sendInvite: function(processComplete, that){
            var that = (that) ? that : this,
                first_name = that.$el.find('.js-invite-first-name-input'),
                first_name_feedback = that.$el.find('.js-invite-first-name-input-feeback'),
                last_name = that.$el.find('.js-invite-last-name-input'),
                last_name_feedback = that.$el.find('.js-invite-last-name-input-feeback'),
                email = that.$el.find('.js-invite-email-input'),
                email_feedback = that.$el.find('.js-invite-email-name-input-feeback'),
                form_feedback = false;

            that.patterns = Backbone.Validation.patterns;
            that.formSubmitted = true;

            if(!that.validateName(first_name, first_name_feedback)){
                form_feedback = true;
            }
            if(!that.validateName(last_name, last_name_feedback)){
                form_feedback = true;
            }
            if(!that.validateEmail(email, email_feedback)){
                form_feedback = true;
            }
            
            if(!form_feedback){

                var data = {
                    FN: first_name.val(),
                    LN: last_name.val(),
                    E : encrypt(email.val())
                };

                $.ajax({
                    type       : 'POST',
                    url        : pf.consumerURL + '/Invitation',
                    async      : false,
                    contentType: 'application/json',
                    data       : JSON.stringify(data),
                    success    : function(modelStatus, respStatus, options){

                        if(processComplete.name){
                            that.invite_button[processComplete.name](true);
                        } else {
                            processComplete(true, that.invite_button);
                        }

                    },
                    error: function(modelStatus, respStatus, options){

                        if(processComplete.name){
                            that.invite_button[processComplete.name](false);
                        } else {
                            processComplete(false, that.invite_button);
                        }
                        
                    }
                });

            } else {

                if(processComplete.name){
                    that.invite_button[processComplete.name](false);
                } else {
                    processComplete(false, that.invite_button);
                }
                // Setting timeout here in case the email field blur timeout hasn't finished yet
                setTimeout(function(){
                    that.formSubmitted = false;
                },500);
            }
        },

        close: function(){}
    });
});

